// Define constants for ticket price calculation fees
export const PLATFORM_FEE_RATE = 0.05; // 5%
export const PROCESSING_FEE_RATE = 0.029; // 2.9%
export const PROCESSING_FEE_ADDITIONAL = 0.30; // $0.30

// Maximum file size that allow to upload
export const MAXIMUM_FILE_SIZE = 5242880;

export const TICKET_PURCHASE_LIMIT = 8;
export const TOKEN_GATE_PURCHASE_LIMIT = 1;

export const DEFAULT_COUNTRY = 840;
export const DEFAULT_TIMEZONE = 'America/New_York';

export const PAGINATION_CONFIG = {
	DEFAULT_PAGE: 1,
	ITEM_PER_PAGE: 10,
};

export const PEAZ_STANDARD = 31;

export const PROFILE_IMAGE_MAX_WIDTH = 800;
export const PROFILE_COVER_IMAGE_MAX_WIDTH = 1200;
export const EVENT_COVER_IMAGE_MAX_WIDTH = 1200;

export const REGEX_MATCH_CURLY_BRACES_PATTERN = /{(.*?)}/;

export const ROUTE_QUERY_CONNECT_STRIPE_STATUS = 'connect-status';

export const TOTAL_WEEKDAY = 7;

export const mappedWeekOfMonth: Record<number, string> = {
	1: 'first',
	2: 'second',
	3: 'third',
	4: 'fourth',
};